export type GoodsReturnNoteRow = {
  id: number
  code: string
  reference: string
  warehouse: string
  vendor: string
  grnCode: string
  orderCode: string
  date: string
  total: number
}

export type GoodsReturnNoteLine = {
  id: string
  /** GRN line id from GetGrnLines — not sent as goods-return line `id` on Save (use 0). */
  lineApiId?: number
  /** Goods return line PK — send as line `id` on Update only; omit on new returns from GRN. */
  goodsReturnLineId?: number
  itemId?: number
  batchId?: number
  item: string
  batch: string
  grnQuantity: number
  quantityReturned: number
  unitPrice: number
  /** Line discount % from GRN (read-only in UI). */
  discountPercent: number
  /** Selected tax rate id (`tax` on GRN line API). */
  taxRateId: string
  taxPercent: number
}

export function newGoodsReturnLine(): GoodsReturnNoteLine {
  return {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    item: '',
    batch: '',
    grnQuantity: 0,
    quantityReturned: 0,
    unitPrice: 0,
    discountPercent: 0,
    taxRateId: '',
    taxPercent: 0,
  }
}

export function lineTaxableAmount(l: GoodsReturnNoteLine): number {
  const q = Math.max(0, Number(l.quantityReturned) || 0)
  const p = Math.max(0, Number(l.unitPrice) || 0)
  const disc = Math.max(0, Math.min(100, Number(l.discountPercent) || 0))
  const gross = q * p
  return Math.round(gross * (1 - disc / 100) * 10000) / 10000
}

export function lineTaxAmount(l: GoodsReturnNoteLine): number {
  const pct = Math.max(0, Number(l.taxPercent) || 0)
  return Math.round(lineTaxableAmount(l) * (pct / 100) * 10000) / 10000
}

export function lineTotal(l: GoodsReturnNoteLine): number {
  return Math.round((lineTaxableAmount(l) + lineTaxAmount(l)) * 10000) / 10000
}
